<template>
  <div class="service section-gap mt-3">
    <div class="container">
      <div>
        <div class="row">
          <div class="input-group rounded">
            <input
              type="search"
              class="form-control rounded"
              placeholder="Search"
              aria-label="Search"
              @input="search"
              v-model="Model.keyWord"
              aria-describedby="search-addon"
            />
            <span class="mx-2 mt-1 border-0" id="search-addon">
              <i class="fas fa-search"></i>
            </span>
          </div>
        </div>
        <!-- search by category and author -->

        <div class="row">
          <div class="col lg:w-1/3 mt-1">
            <label class="vs-input--label">{{ $t("Category") }} </label>
            <v-select
              class="w-full"
              label="Name"
              v-model="Model.LibraryCategoryID"
              :options="LibraryCategories"
              :reduce="(ID) => ID.ID"
              @input="search"
            />
          </div>
          <div class="col lg:w-1/3 mt-1">
            <label class="vs-input--label">{{ $t("Author") }} </label>
            <v-select
              class="w-full"
              label="Name"
              v-model="Model.AuthorID"
              :options="LibraryAuthors"
              :reduce="(ID) => ID.ID"
              @input="search"
            />
          </div>
          <div class="col lg:w-1/3 mt-2">
            <label class="vs-input--label">{{ $t("Publish Date") }} </label>
            <datepicker
              class="w-full"
              icon-pack="feather"
              icon="icon-search"
              :name="$t('PublishDate')"
              v-model="Model.PublishDate"
              @input="search"
            ></datepicker>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div
              v-for="(item, index) in Audios"
              :key="index"
              :virtualIndex="index"
              class="col-lg-4 col-md-6 mt-2"
            >
              <span
                class="_addtoFav py-2 px-3 position-absolute"
                @click.stop="UpdateStatus(item, index)"
              >
                <i
                  class="fa fa-heart text-white fa-2x"
                  v-if="item.IsFavorite"
                ></i>
                <i class="far fa-heart text-white fa-2x" v-else></i>
              </span>
              <img
                v-if="item.ImageURL"
                :src="baseURL + item.ImageURL"
                alt=""
                height="250"
                class="card-img-top border-bottom"
              />
              <img
                v-else
                src="/static/img/enNotAvail.png"
                alt=""
                height="250"
                class="card-img-top border-bottom"
              />
              <span
                class="_addtoFav PlayIcon py-2 px-3 position-absolute"
                @click.stop="PlayAudio(item)"
              >
                <i
                  class="fas fa-play-circle text-primary fa-4x"
                  style="
                    crusor: pointer;
                    background-color: white;
                    border-radius: 50%;
                  "
                ></i>
              </span>
              <div class="card-body position-relative">
                <div class="justify-content-between">
                  <p>{{ item.AuthorName }}</p>
                  <h4 class="card-title text-truncate font-weight-bold">
                    {{ item.Name }}
                  </h4>

                  <!-- <i
                          v-if="IsLoved"
                          class="fa fa-heart font-2x text-warning"
                        ></i> -->
                  <!-- <i  class="far fa-heart text-warning"></i> -->

                  <!-- <router-link
                        to="/product-detail"
                        class="square-40 bg-white rounded-circle text-dark card-shadow"
                      >
                        <i class="fa fa-heart text-warning"></i>
                        <i class="far fa-heart"></i>/
                      </router-link> -->
                </div>
                <div class="card-subtitle text-muted text-truncate my-2">
                  {{ item.Brief }}
                </div>
                <!-- <button class="rounded-pill text-white btn btn-primary">
                  {{ $t("Continue") }}
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ref="Audios"></div>
  </div>
</template>

<script>
import { domain } from "@/globalComponents.js";
import modulePageDetails from "@/store/PageDetails/modulePageDetails.js";
import Datepicker from "vuejs-datepicker";

export default {
  name: "carrousel",
  data() {
    return {
      searchactive: false,
      baseURL: domain,
      Audios: [],
      LibraryCategories: [],
      LibraryAuthors: [],
      Model: {
        name: "",
        authorName: "",
        publishHouse: "",
        pageNumber: 1,
        isPaging: true,
        keyWord: "",
        pageCount: 20,
      },
      isDone: false,
      isMounted: false,
    };
  },
  computed: {
    // filteredList() {
    //   return this.Audios.filter((Element) => {
    //     return Element.name.toLowerCase().includes(this.Model.keyWord.toLowerCase());
    //   });
    // },
  },
  components: {
    Datepicker,
  },
  methods: {
    PlayAudio(URL) {
      debugger
      this.$store.commit("AudioUrl", URL.URL);
      this.$store.dispatch("auth/SetActivityLog", URL.ID);
    },
    UpdateStatus(item, index) {
      if (this.$store.state.auth.isUserLoggedIn()) {
        let model = {};
        model.libraryID = item.ID;
        this.$store
          .dispatch("DataList/ToggleUserFavorite", model)
          .then(() => {
            this.Audios[index].IsFavorite = !this.Audios[index].IsFavorite;
          })
          .catch(() => {});
        return false;
      } else {
        this.$toasted.show(this.$t("PleaseLoginFirst"), {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
        });
        return true;
      }
    },
    onScroll() {
      debugger;
      if (!this.isDone && this.isMounted) {
        var usersHeading = this.$refs["Audios"];
        if (usersHeading) {
          var marginTopUsers = usersHeading.getBoundingClientRect().top;
          var innerHeight = window.innerHeight;

          if (marginTopUsers - innerHeight < -50) {
            this.loadMore();
          }
        }
      }
    },

    loadMore() {
      this.Model.pageNumber += 1;
      this.$store
        .dispatch("DataList/GetAllAudios", this.Model)
        .then((response) => {
          if (response.status == 200) {
            debugger;
            if (response.data.data.length > 0) {
              response.data.data.forEach((element) => {
                this.Audios.push(element);
              });
            } else {
              this.isDone = true;
            }
          }
        })
        .catch(() => {});
    },
    search() {
      this.$store.dispatch("DataList/GetAllAudios", this.Model).then((res) => {
        if (res.status == 200) {
          debugger;
          this.Audios = res.data.data;
          this.isMounted = true;
        }
      });
    },
  },
  created() {
    if (!modulePageDetails.isRegistered) {
      this.$store.registerModule("DetailsList", modulePageDetails);
      modulePageDetails.isRegistered = true;
    }
    this.$store.dispatch("DetailsList/GetAllLibraryCategory").then((res) => {
      this.LibraryCategories = res.data.data;
    });
    this.$store.dispatch("DetailsList/GetAllLibraryAuth").then((res) => {
      this.LibraryAuthors = res.data.data;
    });
    this.search();
  },
  mounted() {
    this.$nextTick(function () {
      window.addEventListener("scroll", this.onScroll);
      this.onScroll(); // needed for initial loading on page
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>

<style lang="scss">
.PlayIcon {
  top: 45%;
  right: 30px;
  z-index: 500;
}
._cartBtn {
  left: 1.25rem;
}

._addtoFav {
  cursor: pointer;
}
</style>
